<template>
  <div class="about">
    <!-- banner部分 -->
    <div class="about-banner">
      <div>
        <h2>斐宸数字科技(上海)有限公司</h2>
      </div>
    </div>
    <!-- 关于斐宸 -->
    <div class="container clearfix">
      <div class="about-title">关于斐宸</div>
      <div>
        <div class="content-left fl">
          <img src="../../assets/img/home/brief_introduction_Image.png" alt="" />
        </div>
        <div class="content-right fr">
          <h2>斐宸数字科技(上海)有限公司</h2>
          <p>
            斐宸数字科技（上海）有限公司（原上海斐宸电子科技有限公司，以下简称
            “公司”）是一家集软件研发、硬件制造及运维服务于一体的高新技术企业。公司始终坚持核心技术自主研发和创新，长期在人工智能算法、物联网、云计算、大数据、虚拟化等技术上创新科研，打造了集“智慧管理、智慧环境、智慧安全、智慧生活、智慧服务”为一体的高度集成且互联互通的智联共享云平台。通过统一开放的接口和数据平台，公司将产品平台模块化并整合联动，以智能识别、数据融合、移动计算、云计算等大数据技术的研究应用为核心，构建各类“互联网+”解决方案。着力为教育行业、交通行业、大型企事业、各类社区工地提供专业且贴切满足客户需求的产品解决方案及运营服务。
          </p>
          <p>公司拥有自主研发生产多项软件著作权、专利及多系列核心硬件产品，以“智慧的架构、智慧的服务、智慧的管理、智慧的运维、智慧的感知”五大智慧设计，在行业内处于领先地位。以物联网平台、业务平台以及服务平台为基础，提供智慧校园、智慧物业、智慧工地、智慧政企、智慧医院等解决方案。</p>
          <p>公司在全国各地拥有多家代理商，已累计服务学校用户超3000所，为多所大型工地园区提供智能化建设方案，并持续为大型企事业单位提供长期服务。公司以高品质的产品，专业可靠的技术，完善的售后服务，为我们在行业中赢得了客户的广泛认可。公司的产品远销全国，其中在上海、江苏、浙江、安徽、山东、河北、广西、江西、陕西、辽宁等地区建立了长期合作供销商。</p>
        </div>
      </div>
    </div>
    <!-- 企业宗旨 -->
    <div class="container clearfix">
      <div class="about-title about-culture-title">企业宗旨</div>
      <div class="about-culture clearfix">
        <div class="about-culture-top clearfix">
          <div class="fl about-culture-list1">
            <a href="">以客户为中心</a>
          </div>
          <div class="fr about-culture-list2">
            <a href="">以奋斗着为本</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业使命 -->
    <div class="container clearfix">
      <div class="about-title">企业使命</div>
      <div class="about-mission">
        <ul class="clearfix">
          <li class="about-mission-list1 fl">
            <a href="">推进产业开发</a>
          </li>
          <li class="about-mission-list2 fl">
            <a href="">促进产业合作</a>
          </li>
          <li class="about-mission-list3 fr">
            <a href="">引领产业创新</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 企业精神 -->
    <div class="clearfix">
      <div class="about-title">企业精神</div>
      <div class="about-strength clearfix">
        <div class="about-strength-list1 fl">
          <p>科技引领</p>
        </div>
        <div class="about-strength-list2 fl">
          <p>服务创新</p>
        </div>
        <div class="about-strength-list3 fl">
          <p>共生共享</p>
        </div>
      </div>
    </div>
    <!-- 我们的服务 -->
    <div class="container clearfix">
      <div class="about-title">我们的服务</div>
      <div class="about-map">
        <!-- 左边的图示 -->
        <div class="graphic">
          <p>
            <i class="icon-red"></i>
            <span>上海总公司</span>
          </p>
          <p>
            <i class="icon-blue"></i>
            <span>办事处</span>
          </p>
          <p>
            <i class="icon-lightblue"></i>
            <span>服务地区</span>
          </p>
        </div>
        <!-- 地图上面的地区 -->
        <div class="map-area">
          <p class="area1">
            新疆维吾尔自治区
            <b>新疆维吾尔自治区</b>
          </p>
          <p class="area2">
            陕西省
            <b>陕西省</b>
          </p>
          <p class="area3">
            四川省
            <b>四川省</b>
          </p>
          <p class="area4">
            云南省
            <b>云南省</b>
          </p>
          <p class="area5">
            广西省
            <b>广西省</b>
          </p>
          <p class="area6">
            山东省
            <b>山东省</b>
          </p>
          <p class="area7">江苏省<b>江苏省</b></p>
          <p class="area8">上海市<b>上海市</b></p>
          <p class="area9">浙江省<b>浙江省</b></p>
        </div>
        <div class="flag-blue"><i class="area7-flag1"></i><em class="branch-lygang">连云港办事处</em><i class="area7-flag2"></i><em class="branch-ycheng">盐城办事处</em></div>
        <div class="flag-red"><i></i><em>斐宸数字科技(上海)有限公司</em></div>
      </div>
    </div>
    <!-- 发展历程 -->
    <div class="container clearfix">
      <div class="about-title">发展历程</div>
      <div class="about-develop">
        <ul class="develop-img fl">
          <li>
            <img src="../../assets/img/about/course_Image_one.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_eight.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_seven.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_two.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_three.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_four.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_five.png" alt="" />
          </li>
          <li>
            <img src="../../assets/img/about/course_Image_six.png" alt="" />
          </li>
        </ul>
        <div class="develop-line fl">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul class="develop-content clearfix fl">
          <li>
            <div class="develop-content-date fl">今天</div>
          </li>
          <li>
            <div class="develop-content-date fl">2023年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>被评为2023年度上海市“专精特新”中小企业</li>
                <li>斐宸智慧校园平台V2.0.745版本研发升级完成并投产</li>
                <li>宿迁某高职院校成功上线斐宸智慧校园平台V2.0.745版本</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2022年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>实现斐宸智慧校园系列产品集,应用软件开发平台的升级</li>
                <li>斐宸嵌入软件开发框架的形成</li>
                <li>新增软件著作权12项，实用新型专利3项</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2021年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>公司业绩突破3500万</li>
                <li>创新资金申请成功</li>
                <li>新成立合肥办事处</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2020年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>获得高新技术企业；</li>
                <li>我司承接《上海工商职业技术学院》项目荣获建设银行全国优秀项目；</li>
                <li>我司市场覆盖浙江、山东，江苏，广西，新疆，陕西．上海等省市20个下辖市。</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2019年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>公司完成著作权12项，实用新型专利3项，信息安全管理体系认证2项，信用等级认正1项， 质量管理体系认正2项，创新企业培育入库。</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2018年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>成功交付自主系统集成项目普教30所，高校5所，政企客户6家完成交付，客户满意度达100%</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2017年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>智慧校园建设配套硬件覆盖约500所大中院校。</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="develop-content-date fl">2016年</div>
            <div class="develop-content-text fl">
              <ul>
                <li>公司成立前期，创业团队主要成员在智慧交通，智慧教育、智慧制造等领域有丰富的行业阅 历和技术沉淀。公司决定以智慧教育为未来发展方向，于2016年6月 在上海注册成立。</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
};
</script>
<style scoped>
.about-banner {
  width: 100%;
  height: 594px;
  line-height: 594px;
  background: #000;
}
.about-banner div {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/about/background_Image.png) no-repeat;
  background-size: cover;
}
.about-banner h2 {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.about-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #333;
}
.content-left {
  margin-bottom: 100px;
  width: 570px;
  height: 380px;
  background-color: #0076de;
}
.content-right {
  margin-bottom: 100px;
  width: 582px;
  height: 380px;
}
.content-right h2 {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.content-right p {
  width: 100%;
  line-height: 1.6;
  font-size: 14px;
  font-weight: 400;
  text-indent: 2em;
  color: #666;
}
.about-culture div div {
  width: 571px;
  height: 380px;
  background: #000;
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.about-culture div a {
  width: 100%;
  height: 100%;
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  display: block;
  line-height: 380px;
  text-align: center;
}
.about-culture .about-culture-top .about-culture-list1 a {
  background: url(../../assets/img/about/purpose_Image_one.png);
}
.about-culture-list2 a {
  background: url(../../assets/img/about/purpose_Image_two.png);
}
.about-mission {
  margin-bottom: 200px;
  width: 1200px;
  display: table;
  margin-left: auto;
  margin-right: auto;
}
.about-mission ul {
  display: table;
  margin-right: -60px;
}
.about-mission ul li {
  position: relative;
  float: left;
  width: 360px;
  height: 380px;
  margin-right: 60px;
  background-color: #000;
  border-radius: 10px;
}
.about-mission ul li a {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 380px;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #fff;
}
.about-mission-list1 a {
  background: url(../../assets/img/about/mission_Image_one.png);
}
.about-mission-list2 a {
  background: url(../../assets/img/about/mission_Image_two.png);
}
.about-mission-list3 a {
  background: url(../../assets/img/about/mission_Image_three.png);
}
.about-culture .fr {
  margin-right: 0px;
}
.about-strength {
  width: 100%;
  margin: 0 auto;
  height: 380px;
  background: #000;
}
.about-strength .about-strength-list1 {
  margin-left: -1.7%;
  width: 36.5%;
  height: 100%;
  background: url(../../assets/img/about/spirit_Image_one.png) no-repeat;
  background-size: cover;
}
.about-strength .about-strength-list2 {
  margin-left: -4.3%;
  width: 38.6%;
  height: 100%;
  background: url(../../assets/img/about/spirit_Image_two.png) no-repeat;
  background-size: cover;
}
.about-strength .about-strength-list3 {
  margin-left: -4.2%;
  width: 35.1%;
  height: 100%;
  background: url(../../assets/img/about/spirit_Image_three.png) no-repeat;
  background-size: cover;
}
.about-strength .fl p {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  line-height: 380px;
}
.about-map {
  position: relative;
  width: 100%;
  height: 900px;
  background: url(../../assets/img/about/Map.png);
}
.graphic {
  position: absolute;
  bottom: 0;
  left: 20px;
  font-size: 18px;
  font-weight: 400;
  color: #000;
}
.graphic i {
  display: inline-block;
  margin-top: 8px;
  width: 25px;
  height: 25px;
  margin-right: 20px;
  vertical-align: top;
}
.graphic span {
  line-height: 1.7;
}
.graphic .icon-red {
  background: url(../../assets/img/about/flag_red.png);
}
.graphic .icon-blue {
  background: url(../../assets/img/about/flag_blue.png);
}
.graphic .icon-lightblue {
  width: 25px;
  height: 17px;
  background: #4193ff;
}
.map-area p {
  font-size: 18px;
  font-weight: 400;
  color: #000;
  cursor: pointer;
}
.about-map i {
  display: inline-block;
  width: 25px;
  height: 25px;
}
.map-area p:hover b {
  display: block;
  text-align: center;
  position: absolute;
  transform: scale(1.3);
}
.about-map em {
  font-size: 12px;
  font-style: normal;
}
.area1 {
  position: absolute;
  left: 166px;
  top: 310px;
}
.area1 b {
  left: -166px;
  top: -197px;
  width: 448px;
  height: 387px;
  line-height: 387px;
  background: url(../../assets/img/about/map_xinjiang.png);
  display: none;
}
.area2 {
  position: absolute;
  left: 660px;
  top: 483px;
}
.area2 b {
  display: block;
  left: -37px;
  top: -120px;
  width: 115px;
  height: 206px;
  line-height: 206px;
  background: url(../../assets/img/about/map_shanxi.png);
  display: none;
}
.area3 {
  position: absolute;
  left: 545px;
  top: 585px;
}
.area3 b {
  display: block;
  left: -80px;
  top: -87px;
  width: 221px;
  height: 217px;
  line-height: 217px;
  background: url(../../assets/img/about/map_sichuan.png);
  display: none;
}
.area4 {
  position: absolute;
  left: 523px;
  top: 741px;
}
.area4 b {
  display: block;
  left: -56px;
  top: -110px;
  width: 172px;
  height: 213px;
  line-height: 213px;
  background: url(../../assets/img/about/map_yunnan.png);
  display: none;
}
.area5 {
  position: absolute;
  left: 660px;
  top: 767px;
}
.area5 b {
  display: block;
  left: -57px;
  top: -62px;
  width: 151px;
  height: 132px;
  line-height: 132px;
  background: url(../../assets/img/about/map_guangxi.png);
  display: none;
}
.area6 {
  position: absolute;
  left: 844px;
  top: 436px;
}
.area6 b {
  display: block;
  left: -40px;
  top: -40px;
  width: 155px;
  height: 105px;
  line-height: 105px;
  background: url(../../assets/img/about/map_shandong.png);
  display: none;
}
.area7 {
  position: absolute;
  left: 874px;
  top: 526px;
}
.area7 b {
  display: block;
  left: -40px;
  top: -48px;
  width: 111px;
  height: 115px;
  line-height: 115px;
  background: url(../../assets/img/about/map_jiangsu.png);
  display: none;
}
.flag-blue i {
  background: url(../../assets/img/about/flag_blue.png);
}
.area7-flag1 {
  position: absolute;
  top: 472px;
  left: 891px;
}
.area7-flag2 {
  position: absolute;
  top: 498px;
  left: 915px;
}
.branch-lygang {
  position: absolute;
  top: 474px;
  left: 930px;
  display: none;
}
.branch-ycheng {
  display: none;
  position: absolute;
  top: 500px;
  left: 955px;
}
.area8 {
  position: absolute;
  left: 949px;
  top: 576px;
}
.area8 b {
  display: block;
  left: -26px;
  top: -4px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  font-size: 12px;
  background: url(../../assets/img/about/map_shanghai.png);
  display: none;
}
.flag-red i {
  position: absolute;
  top: 553px;
  left: 934px;
  background: url(../../assets/img/about/flag_red.png);
}
.flag-red em {
  display: none;
  position: absolute;
  top: 554px;
  left: 970px;
}
.area9 {
  position: absolute;
  left: 883px;
  top: 624px;
}
.area9 b {
  display: block;
  top: -44px;
  right: -11px;
  width: 82px;
  height: 108px;
  line-height: 108px;
  background: url(../../assets/img/about/map_zhejiang.png);
  display: none;
}
.area7-flag1,
.area7-flag2,
.flag-red i {
  cursor: pointer;
}
.area7-flag1:hover + em,
.area7-flag2:hover + em,
.flag-red i:hover + em {
  display: block;
  width: 200px;
}
.about-develop {
  height: 768px;
  margin-bottom: 100px;
}
.develop-img {
  width: 271px;
  padding-right: 58px;
}
.develop-img li {
  width: 213px;
  height: 93px;
  margin-top: 30px;
  margin-bottom: 26px;
}
.develop-img li:first-child {
  margin-top: -40px;
}
.develop-img li img {
  width: 100%;
  height: 100%;
}
.develop-line {
  position: relative;
  width: 2px;
  height: 982px;
  background: #abcdf7;
  opacity: 0.8;
}
.develop-line span {
  position: relative;
  left: -9px;
  display: block;
  width: 20px;
  height: 20px;
  background: #ffffff;
  border: 4px solid #0076de;
  border-radius: 50%;
  margin-bottom: 100px;
}
.develop-line span:nth-child(1) {
  margin-bottom: 50px;
}
.develop-content {
  margin-top: -10px;
  padding-left: 60px;
  width: 915px;
  height: 100%;
}
.develop-content > li {
  position: relative;
  width: 100%;
  height: 82px;
  margin-bottom: 37px;
}
.develop-content-date {
  position: relative;
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}
.develop-content > li:nth-child(1) {
  height: 40px;
}
.develop-content-text {
  padding-left: 57px;
}
.develop-content-text ul {
  width: 702px;
}
.develop-content-text li {
  list-style-type: disc;
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
